import Municipio from "./municipio";

class IPSView {
  public id: number;
  public nombre_ips: string;
  public cod_ips: string;
  public is_active: boolean;
  public municipio_id: Municipio; // Cambiado para reflejar el nombre de la columna del backend
  public id_municipio_id: number;
  public date_contract: Date;
  public have_contract: boolean;
  public date_update2025: Date;
  public have_lovelace: boolean
  public have_movile: boolean
  public count_movile: string
  public data_a: string
  public connection: string
  public password_connection: string
  public name_server: string
  public password_server: string
  public date_updated: string
  public have_actualization:boolean
  public comment?: string
  public date_cut_off?: string;


  constructor(
    id: number,
    nombre_ips: string,
    cod_ips: string,
    is_active: boolean,
    municipio_id: Municipio,
    id_municipio_id: number,
    date_contract: Date,
    have_contract: boolean,
    date_update2025: Date,
    have_lovelace: boolean,
    have_movile: boolean,
    count_movile: string,
    data_a: string,
    connection: string, 
    password_connection: string, 
    name_server: string,
    password_server: string, 
    date_updated: string,
    have_actualization:boolean
  ) {
    this.id = id;
    this.nombre_ips = nombre_ips;
    this.cod_ips = cod_ips;
    this.is_active = is_active;
    this.municipio_id = municipio_id;
    this.id_municipio_id = id_municipio_id;
    this.date_contract = date_contract;
    this.have_contract = have_contract;
    this.date_update2025 = date_update2025;
    this.have_lovelace = have_lovelace;
    this.have_movile = have_movile;
    this.count_movile = count_movile;
    this.data_a = data_a;
    this.connection = connection;
    this.password_connection = password_connection
    this.name_server = name_server
    this.password_server = password_server
    this.date_updated = date_updated
    this.have_actualization = have_actualization
  }
}

export default IPSView;
